import type { CustomAttributeData } from '@risksmart-app/domain/src/types/common.types';
import type { UpdateDocumentOversightResultMutation } from '@risksmart-app/web-graphql-client/generated/graphql';
import { UpdateDocumentOversightResultDocument } from '@risksmart-app/web-graphql-client/generated/graphql';

import { createMutationHook } from '@/utils/hook-factories';

export type UpdateDocumentOversightResultInput = {
  Id: string;
  Rating?: number | null;
  Rationale?: string | null;
  TestDate?: string | null;
  CustomAttributeData?: CustomAttributeData | null;
};

export const useUpdateDocumentOversightResult = createMutationHook({
  name: 'updateDocumentOversightResult',
  mutationOptions: (trpc, onSuccess) =>
    trpc.frontend.assessment.updateDocumentOversightResult.mutationOptions({
      onSuccess,
    }),
  mapInput: (input: UpdateDocumentOversightResultInput) => input,
  invalidate: (trpc) => [
    // Apollo parity: evictField(cache, 'document_oversight_result')
    trpc.frontend.assessment.getOversightResultsByParentId.pathKey(),
    trpc.frontend.assessment.getAllOversightAssessmentResults.queryKey(),
    trpc.frontend.assessment.oversightResultById.pathKey(),
    trpc.frontend.assessment.documentOversightResultById.pathKey(),
    trpc.frontend.assessment.oversightAssessmentDocumentAssessmentResultsByDocumentId.pathKey(),
    // Apollo parity: evictField(cache, 'document_oversight_result_aggregate')
    trpc.frontend.assessment.oversightAssessmentResultCount.queryKey(),
    // Apollo parity: evictField(cache, 'oversight_assessment')
    trpc.frontend.assessment.oversightActivityRegister.queryKey(),
    trpc.frontend.assessment.oversightActivityCount.queryKey(),
  ],
  mapResponse: (): UpdateDocumentOversightResultMutation => ({
    update_document_oversight_result: {
      __typename: 'document_oversight_result_mutation_response',
      affected_rows: 1,
    },
  }),
  graphqlDocument: UpdateDocumentOversightResultDocument,
  graphqlVariables: (input: UpdateDocumentOversightResultInput) => ({
    Id: input.Id,
    Rating: input.Rating,
    Rationale: input.Rationale,
    TestDate: input.TestDate,
    CustomAttributeData: input.CustomAttributeData ?? null,
  }),
  evictFields: [
    'document_oversight_result',
    'oversight_assessment',
    'document_oversight_result_aggregate',
  ],
});
